<template>
	<button
		type="button"
		class="inline-flex gap-2 items-center button small rounded-md bg-blue-100 border-blue-100 shadow-none text-gray-900 hover:bg-blue-50 hover:border-blue-50"
		id="syncEnrollmentsButton"
		@click="syncEnrollments">
		<SvgIcon :class="{ 'animate-spin': inProgress }" icon="arrow-path" size="sm" weight="bold" />
		<span class="text-sm">Sync Enrollments</span>
	</button>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import axios from "axios";
import $events from "@/event-bus.ts";

export default defineComponent({
	props: {
        userUuid: String,
        cloverAdminUuid: String
	},
	methods: {
        syncEnrollments() {
            this.inProgress = true;
            axios.post(`/admin/accounts/users/product/enrollments/sync`, {
                userUuid: this.userUuid,
                cloverAdminUuid: this.cloverAdminUuid
            })
                .then(r => {
                    $events.$emit("toastNotification", {
                    action: "updated",
                    heading: "Enrollments Successfully Synced! Please refresh the page to see updated enrollments.",
                    status: "saved",
                });

                    // Refresh the page
                    window.location.reload()
                })
                .catch(e => {
                    $events.$emit("toastNotification", {
                    action: "error",
                    heading: "Failed to Sync Enrollments For User",
                    message: e.message,
                    status: "error",
                });
                })
                .finally(() => this.inProgress = false);
        }
	},
    setup() {
        const inProgress = ref(false);

        return {
            inProgress
        };
    },
});
</script>

<style>
.no-scroll {
	overflow: hidden;
}
</style>
